// extracted by mini-css-extract-plugin
export default {"spanInfoWarning":"Legenda_spanInfoWarning__ue+ly","labelInfoWarning":"Legenda_labelInfoWarning__9yKIb"};